import { useEffect, useState } from 'react'
import { useIsFeatureEnabled } from './FeatureTogglesProvider'
import { DEFAULT_FEATURE_TOGGLE_VALUES, FEATURE_TOGGLES } from './utils'

const STATION_PASSPORT_DONATION_FEATURE_FLAG =
  FEATURE_TOGGLES.stationPassportDonation

const useIsStationPassportDonationEnabled = (): {
  isStationPassportDonationEnabled: boolean
  isLoading: boolean
} => {
  const isFeatureEnabled = useIsFeatureEnabled(
    STATION_PASSPORT_DONATION_FEATURE_FLAG
  )
  const [
    isStationPassportDonationEnabled,
    setIsStationPassportDonationEnabled,
  ] = useState<boolean>(
    Boolean(
      DEFAULT_FEATURE_TOGGLE_VALUES[STATION_PASSPORT_DONATION_FEATURE_FLAG]
    )
  )
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    isFeatureEnabled()
      .then((value) => {
        setIsStationPassportDonationEnabled(Boolean(value))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [isFeatureEnabled])

  return { isStationPassportDonationEnabled, isLoading }
}

export default useIsStationPassportDonationEnabled
